import Vue from 'vue';
// cookie
import Cookie from "js-cookie";
// 请求
import request from '../request';
// 通用工具
import { str as toolsStr } from '../utils/tools';
import store2 from '../store2';

// 获取浏览器类型
const getBrowserType = () => {
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    var isOpera = userAgent.indexOf("Opera") > -1; //判断是否Opera浏览器
    var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera || userAgent.indexOf("rv:11") > -1; //判断是否IE浏览器
    var isEdge = userAgent.indexOf("Windows NT 6.1; Trident/7.0;") > -1 && !isIE; //判断是否IE的Edge浏览器
    var isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器
    var isSafari = userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") == -1; //判断是否Safari浏览器
    var isChrome = userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Safari") > -1; //判断Chrome浏览器
    if (isIE) {
        if (userAgent.indexOf("rv:11") > -1) {
            return "IE11";
        }
        if (userAgent.indexOf("rv:12") > -1) { //这一段还没验证
            return "IE12";
        }
        var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        var fIEVersion = parseFloat(RegExp["$1"]);
        if (fIEVersion >= 9) {
            return 'IE' + fIEVersion
        }
    }
    if (isFF) { return "Firefox"; }
    if (isOpera) { return "Opera"; }
    if (isSafari) { return "Safari"; }
    if (isChrome) { return "Chrome"; }
    if (isEdge) { return "Edge"; }
};

export default {
    $vue: Vue,
    $win: window,
    $axios: request.axios,
    $cookie: Cookie,
    $get: request.get,
    $store2: store2,
    $post: request.post,
    $strEncode: toolsStr.encode,
    $strDecode: toolsStr.decode,
    $env: {
        browser: getBrowserType(),
    }
}